import React from "react";
import {
  ButtonBase,
  CircularProgress,
  Dialog,
  Slide,
  Typography,
} from "@mui/material";
import styles from "./Style.module.css";
import GiftDetailsIncludeForm from "./component/GiftDetailIncludes/GiftDetailsIncludes.component";
import useGiftStoreCreateHook from "./GiftStoreHook";
import { useTheme } from "@mui/styles";
import { PrimaryButton } from "../../../../../components/Buttons/PrimaryButton";
import CloseIcon from "@mui/icons-material/Close";
import CustomCheckbox from "../../../../../components/FormFields/CustomCheckbox";
import FilterComponent from "../../../../../components/Filter/Filter.component";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const GiftStoreCreate = ({ isOpen, handleToggle, editData, updateGiftList }) => {
  const {
    form,
    changeTextData,
    handleSubmit,
    isSubmitting,
    shiftRef,
    handleSearchValueChange,
    data,
    updateTableData,
    setForm,
  } = useGiftStoreCreateHook({
    isOpen,
    handleToggle,
    editData,
    updateGiftList
  });
  const theme = useTheme();

  return (
    <Dialog
      onBackdropClick={() => {}}
      keepMounted
      fullWidth={true}
      maxWidth={"md"}
      TransitionComponent={Transition}
      open={isOpen}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className={styles.DialogWrap}>
        <div className={styles.Wrappper}>
          <div>
            <Typography variant={"subtitle1"}>Associate Gifts</Typography>
          </div>

          <ButtonBase onClick={handleToggle}>
            <CloseIcon />
          </ButtonBase>
        </div>
        <FilterComponent
          // disabled={editData ? true : false}
          filters={[]}
          is_progress={false}
          handleSearchValueChange={handleSearchValueChange}
          placeholder={"Search by gift title"}
        />
        <div className={styles.container}>
          <div className={styles.shiftcontainer}>
            <div
              className={styles.shiftHeader}
              style={{ background: theme.palette.tableHeadColor }}
            >
              <div className={styles.divHead221}>
                <CustomCheckbox
                  // disabled={editData}
                  color={"primary"}
                  handleChange={() => {
                    changeTextData(!form?.select_all, "select_all");
                  }}
                  checked={form?.select_all}
                />
              </div>
              <div className={styles.divHead}>
                <Typography
                  variant="subtitle1"
                  color={theme.palette.text.primary}
                >
                  Gift Title
                </Typography>
              </div>
              <div className={styles.divHead}>
                <Typography
                  variant="subtitle1"
                  color={theme.palette.text.primary}
                >
                  Type
                </Typography>
              </div>
              {/* <div className={styles.divHead}>
                <Typography
                  variant="subtitle1"
                  color={theme.palette.text.primary}
                >
                  Sub Type
                </Typography>
              </div> */}
              <div className={styles.divHead}>
                <Typography
                  variant="subtitle1"
                  color={theme.palette.text.primary}
                >
                  Points Required
                </Typography>
              </div>
            </div>
            {data.length === 0 ? (
              <div className={styles.noResults}>
                <div className={styles.noData}>
                  <img
                    src={require("../../../../../assets/img/ic_search_empty@2x.png")}
                    height={140}
                    width={140}
                    style={{ marginTop: "25px" }}
                    className={styles.noData}
                  />
                </div>
                <Typography
                  variant="subtitle1"
                  color={theme.palette.text.secondary}
                >
                  No results found
                </Typography>
                <div style={{ fontSize: "0.7rem", fontWeight: "500" }}>
                  No matching entries available in our record
                </div>
              </div>
            ) : (
            <GiftDetailsIncludeForm
              ref={shiftRef}
              isSidePanel={isOpen}
              data={data}
              updateTableData={updateTableData}
              setForm={setForm}
            />
          )}
          </div>

          <div className={styles.actionButton}>
          {data.length > 0 && (
            <PrimaryButton onClick={handleSubmit}>
              {isSubmitting ? (
                <CircularProgress color="success" size="20px" />
              ) : (
                " SAVE"
              )}
            </PrimaryButton>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default GiftStoreCreate;
